<mat-form-field
  [solQueryPicker]="modules"
  [multiple]="true"
  [selectedItems]="selectedModules"
  (pick)="onPicked($event)"
  displayProperty="name"
  appearance="outline"
  floatLabel="always"
  class="module-picker-input"
>
  <mat-label>{{ label }}</mat-label>

  <mat-chip-grid #chipList aria-label="Module selection">
    <mat-chip
      *ngFor="let module of selectedModules || []"
      (click)="inputRef.click()"
    >
      {{ module.name }}
    </mat-chip>
    <input #inputRef [style.max-height.px]="0" [matChipInputFor]="chipList" />
  </mat-chip-grid>
  <mat-hint>{{ hint || selectedModuleIds.length + 0 + " Selected" }}</mat-hint>
</mat-form-field>
